import { useCallback } from 'react';

const useSupportChat = () => {
  const openSupportChat = useCallback(() => {
    if (typeof globalThis.Intercom === 'function') {
      globalThis.Intercom('show');
    } else {
      console.warn(
        'Intercom is not available; support chat could not be opened.',
      );
    }
  }, []);

  return { openSupportChat };
};

export default useSupportChat;
